'use client'

import { ButtonLink, PaymentType } from '@repo/shared/components'
import { Icon, Row, Skeleton, Typography } from '@repo/ui/components'
import { useParams } from 'next/navigation'
import { useUserPortfolio } from '@repo/services'
import { useTranslate } from '@repo/shared/hooks'
import { useMemo } from 'react'

export const BalanceAssetCTA = ({
  origin,
}: {
  origin: 'layout' | 'container'
}) => {
  const { id } = useParams()

  const { t } = useTranslate()

  const { data: { data: { accounts = [] } = {} } = {} } = useUserPortfolio()

  const currency = id

  const account = useMemo(() => {
    return accounts?.find((account) => account.currency === currency)
  }, [accounts, currency])

  return (
    <Row
      className={`${origin === 'layout' ? 'sticky top-0' : ''}  justify-between h-fit gap-md p-xs bg-neutral-surface-light`}
    >
      <ButtonLink
        variant='transparent'
        color='neutral'
        size='md'
        href='/wallet'
        aria-label='Back to Wallet'
        startIcon={<Icon name='ArrowRightLine' size='md' className='mt-xs' />}
      />
      <Typography size='md' weight='bold' className='flex-1'>
        {account?.currency === 'MALEK'
          ? t('walletPage_malek_balance')
          : account?.currency}
      </Typography>
    </Row>
  )
}
